import ShortUniqueId from 'short-unique-id';
import { S3CopyPlanToOrder } from '../../helper/s3ClientHandler';
import { getHeaders } from "../utils";

export async function APICreateNewOrder(order, user, fileUrl = false) {
  const companyId = user?.companyId;
  const uid = new ShortUniqueId();
  order.orderId = uid.rnd();

  try {
    const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);


    const requestOptions = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(order),
      redirect: 'follow',
    };

    // Use template literals to construct the URL
    const apiUrl =
      process.env.REACT_APP_MODE === 'PROD'
        ? process.env.REACT_APP_API_INTERNAL_PRODUCTION
        : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
    const response = await fetch(`${apiUrl}/order/1.0/company/${companyId}/order`, requestOptions);
    const responseObject = await response.json();
    const orderData = responseObject?.data;

    if (fileUrl) {
      await S3CopyPlanToOrder(user?.companyId, order.id, fileUrl);
    }

    return orderData;
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
}

export async function APIGetOrder({companyId, id}) {
  try {
    const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);

    const requestOptions = {
      method: 'GET',
      headers: headers,
      redirect: 'follow',
    };

    // Use template literals to construct the URL
    const apiUrl = process.env.REACT_APP_MODE === 'PROD'
        ? process.env.REACT_APP_API_INTERNAL_PRODUCTION
        : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
    const response = await fetch(`${apiUrl}/order/1.0/company/${companyId}/order/${id}`, requestOptions);
    const responseObject = await response.json();
    const order = responseObject?.data;
    return order;

  } catch (error) {
    console.error('Error:', error);
    throw error; // rethrow the error for further handling
  }
}

export async function APIGetMyOrders(type, companyId) {
  try {
    const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);

    const requestOptions = {
      method: 'GET',
      headers: headers,
      redirect: 'follow',
    };

    if (typeof type === 'undefined' || type === null) {
      type = 'all';
    }


    // Use template literals to construct the URL
    const apiUrl =
      process.env.REACT_APP_MODE === 'PROD'
        ? process.env.REACT_APP_API_INTERNAL_PRODUCTION
        : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;



    const response = await fetch(
      `${apiUrl}/order/1.0/company/${companyId}/type/${type}`,
      requestOptions,
    );
    const responseObject = await response.json();
    const orders = responseObject?.data;

    return orders;
  } catch (error) {
    console.error('Error:', error);
    throw error; // rethrow the error for further handling
  }
}

export async function APIGetContractedOrders(type, companyId) {
  try {
    const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);

    const requestOptions = {
      method: 'GET',
      headers: headers,
      redirect: 'follow',
    };

    // Use template literals to construct the URL
    const apiUrl =
      process.env.REACT_APP_MODE === 'PROD'
        ? process.env.REACT_APP_API_INTERNAL_PRODUCTION
        : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
    const response = await fetch(
      `${apiUrl}/order/1.0/company/${companyId}/type/${type}/won`,
      requestOptions,
    );
    const responseObject = await response.json();
    const contractedOrders = responseObject?.data;

    if (contractedOrders.length > 0) {
      contractedOrders.forEach(order => {
        order.name = order?.planId;
      });
      return contractedOrders;
    } else {
      return null;
    }
  } catch (error) {
    console.error('Error:', error);
    throw error; // rethrow the error for further handling
  }
}

export async function APISetOrderStage({orderId, stage, companyId}) {
  try {
    const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);

    if (orderId && stage) {
      var requestOptions = {
        method: 'put',
        headers: headers,
        redirect: 'follow',
      };

      // Use template literals to construct the URL
      const apiUrl =
        process.env.REACT_APP_MODE === 'PROD'
          ? process.env.REACT_APP_API_INTERNAL_PRODUCTION
          : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
      await fetch(
        `${apiUrl}/order/1.0/company/${companyId}/order/${orderId}/setStage/${stage}`,
        requestOptions,
      );
      return null;
    }
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
}

export async function APIDeleteOrder({id, companyId}) {
  try {
    const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);

    const requestOptions = {
      method: 'DELETE',
      headers: headers,
      redirect: 'follow',
    };

    // Use template literals to construct the URL
    const apiUrl =
      process.env.REACT_APP_MODE === 'PROD'
        ? process.env.REACT_APP_API_INTERNAL_PRODUCTION
        : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
    await fetch(`${apiUrl}/order/1.0/company/${companyId}/order/${id}`, requestOptions);
    return true;
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
}

export async function APISaveOrder({order, companyId}) {

  const id = order.id;
  const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);

  const requestOptions = {
      method: 'PUT',
      headers: headers,
      body: JSON.stringify(order),
      redirect: 'follow'
  };

  try {
    const apiUrl =
    process.env.REACT_APP_MODE === 'PROD'
      ? process.env.REACT_APP_API_INTERNAL_PRODUCTION
      : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
    const response = await fetch(`${apiUrl}/order/1.0/company/${companyId}/order/${id}`, requestOptions);
    const responseObject = await response.json();
    const updatedOrder = responseObject?.data;

    return updatedOrder;
  } catch (error) {
      console.error('Error:', error);
      throw error;
  }
}